import { render } from "./FormEditorCmp.vue?vue&type=template&id=3bb460c0"
import script from "./FormEditorCmp.vue?vue&type=script&lang=js"
export * from "./FormEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__